<form class="itinerary-model-content-inner"  [formGroup]="itineraryDetailsForm" (ngSubmit)="onSubmit()">
  <div class="itinerary-model-content">
    <div class="ion-no-padding">
      <ion-title class="dark-title-sm ion-padding-horizontal py-1 bg-light-gray">Details</ion-title>
    </div>
    <div class="form-container ion-padding-horizontal">
      <div class="form-table-grid-container">
        <!-- Form fields container -->
        <div>
          <div class="row">
            <div class="col-12">
              <div class="input-container">
                <label for="" class="label">Itinerary Name* <span class="warning-message" *ngIf="itineraryDetailsForm.get('itineraryName')?.errors?.['maxLengthExceeded']">The maximum length is {{ itineraryDetailsForm.get('itineraryName')?.errors?.['maxLengthExceeded'].maxLength }}</span></label>
                <div [ngClass]="{ 'invalid-input': itineraryDetailsForm.get('itineraryName')?.invalid && itineraryDetailsForm.get('itineraryName')?.touched }">
                  <input class="input-text input" type="text" placeholder="Ex - Goa group trip" formControlName="itineraryName">
                </div>
              </div>
            </div>
          </div>
    
          <ng-container formArrayName="destinationDaysArray">
            <div class="destinations-days-row row" *ngFor="let item of destinationDaysArray.controls; let i = index" [formGroupName]="i">
              <div class="col-7" >
                <div class="input-container">
                  <label for="" class="label">Destination {{i+1}}*</label>
                  <div [ngClass]="{ 'invalid-input': item.get('location')?.invalid && item.get('location')?.touched }">
                    <app-locations-autocomplete formControlName="location" [placeHolder]="'Enter Destination'"></app-locations-autocomplete>
                  </div>
                </div>
                
              </div>
    
              <div class="col-4">
                <div class="input-container">
                  <label for="" class="label">Nights*</label>
                  <div [ngClass]="{ 'invalid-input': item.get('days')?.invalid && item.get('days')?.touched }" >
                    <app-increment-number-input formControlName="days" [max]="365"></app-increment-number-input>
                  </div>
                </div>
              </div>
    
              <div class="col-1 position-relative" style="width: 25px;">
                <div class="btns-container">
                  <ion-button class="add-btn action-btn" (click)="addDestination()" *ngIf="i+1 === destinationDaysArray.controls.length"><ion-icon name="add-outline"></ion-icon></ion-button>
                  <ion-button class="delete-btn action-btn" (click)="removeDestination(i)" *ngIf="destinationDaysArray.controls.length !== 1"><ion-icon name="trash-outline"></ion-icon></ion-button>
                </div>
              </div>
    
              <div class="col-12">
                <div *ngIf="item.get('destinationDays')?.invalid && item.get('destinationDays')?.touched">
                  <p class="text-danger warning-message">Please enter a valid destination and number of days</p>
                </div>
              </div>
            </div>
          </ng-container>
    
          
          <div class="row"  *ngIf="leadId">
    
            <div class="col-6">
              <div class="input-container">
                <label for="" class="label" >Trip Start date*</label>
                <div [ngClass]="{ 'invalid-input': itineraryDetailsForm.get('startDate')?.invalid && itineraryDetailsForm.get('startDate')?.touched }">
                  <app-date-picker [minDate]="today()" formControlName="startDate"></app-date-picker>
                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="input-container">
                <label for="" class="label" >Trip end date</label>
                <div [ngClass]="{ 'invalid-input': itineraryDetailsForm.get('endDate')?.invalid && itineraryDetailsForm.get('endDate')?.touched }">
                  <app-date-picker [minDate]="today()" [isDisabled]="true" formControlName="endDate"></app-date-picker>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12">
            <div class="input-container">
              <label for="" class="label">Package Type</label>
              <div [ngClass]="{ 'invalid-input': itineraryDetailsForm.get('packageType')?.invalid && itineraryDetailsForm.get('packageType')?.touched }">
                <app-dropdown-select [dropdownValues]="dmcPackages" formControlName="packageType"></app-dropdown-select>
              </div>
            </div>
          </div>
    
          <div class="row"  *ngIf="leadId">
            <div class="col-12">
              <div class="input-container">
                <label for="" class="label">No Of Pax* <span class="text-danger warning-message" *ngIf="itineraryDetailsForm.get('noOfGuests')?.hasError('noOfAdultsInvalid') && itineraryDetailsForm.get('noOfGuests')?.touched">Adults cannot be 0</span><span class="text-danger warning-message" *ngIf="itineraryDetailsForm.get('noOfGuests')?.hasError('childrenAgeInvalid') && itineraryDetailsForm.get('noOfGuests')?.touched">Select age for all children</span></label>
                <div [ngClass]="{ 'invalid-input': itineraryDetailsForm.get('noOfGuests')?.invalid && itineraryDetailsForm.get('noOfGuests')?.touched }">
                  <app-no-of-guests-input formControlName="noOfGuests"></app-no-of-guests-input>
                </div>
              </div>
            </div>
          </div>
    
          <div class="row">
            <div class="col-12">
              <div class="input-container">
                <label for="" class="label">Note</label>
                <div [ngClass]="{ 'invalid-input': itineraryDetailsForm.get('sectionNote')?.invalid && itineraryDetailsForm.get('sectionNote')?.touched }">
                  <app-text-formatting-input formControlName="sectionNote"></app-text-formatting-input>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Recommended itinerary container -->
        <div>
          <div *ngIf="showRecommendedItineraries">  
            <div class="px-2">
              <div class="input-container">
                <label for="" class="label">Recommended Itineraries</label>
              </div>
              <div class="recommeneded-itinerary-section">
      
                <table class="table">
                  <thead class="thead-dark sticky-top">
                    <tr>
                      <th>
                        <div class="table-heading">
                          Name
                        </div>
                      </th>

                      <th>
                        <div class="table-heading">
                          Type
                        </div>
                      </th>
          
                      <th>
                        <div class="table-heading">
                          Destination
                        </div>
                      </th>

                      <th>
                        <div class="table-heading">
                          Valid From
                        </div>
                      </th>

                      <th>
                        <div class="table-heading">
                          Valid To
                        </div>
                      </th>
          
                      <th class="options-column">
                        <div class="table-heading border-end-0">
                          Options
                        </div>
                      </th>
                      
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let itinerary of recommenedItinerariesData">
                      <td (click)="(selectedInventoryItineraryId || recommendedItineraryId) !== itinerary?.itineraryId ? openInventoryItinerary(itinerary): null"><span [ngClass]="{'clickable-text': (selectedInventoryItineraryId || recommendedItineraryId) !== itinerary?.itineraryId}">{{this._globalService.trimString(itinerary.itineraryName, 15)}}</span></td>
                      <td>{{itinerary.type}}</td>
                      <td>{{getDestinationsArray(itinerary.destination)}}</td>
                      <td>{{convertToDate(itinerary.validFrom) ? (convertToDate(itinerary.validFrom) | date: "dd MMM, yyy") : "--"}}</td>
                      <td>{{convertToDate(itinerary.validTo) ? (convertToDate(itinerary.validTo) | date: "dd MMM, yyy") : "--"}}</td>
                      <td class="px-0" (click)="(selectedInventoryItineraryId || recommendedItineraryId) !== itinerary?.itineraryId ? createQuote(itinerary) : null"><span style="font-size: 10px;" [ngClass]="{'clickable-text': (selectedInventoryItineraryId || recommendedItineraryId) !== itinerary?.itineraryId}">{{(selectedInventoryItineraryId || recommendedItineraryId) !== itinerary?.itineraryId ? 'Create Quote':'Selected'}}</span></td>
                    </tr>
                    <tr *ngIf="recommenedItinerariesData.length === 0">
                      <td colspan="6" class="text-center">Select desinations and no of days to get recommended itineraries</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div class="dashed-line my-2"></div>
          </div>
        </div>
      </div>
    </div>
    

  </div>
  
  <div class="ion-padding-horizontal bg-light-gray justify-content-center itinerary-model-footer">
    <ion-button class="unfilled-blue-btn" type="button" (click)="goPrevious()" *ngIf="leadId" [disabled]="formDataModified()">
      <ion-icon slot="icon-only" name="chevron-back-outline"></ion-icon>
    </ion-button>
    <ion-button class="unfilled-blue-btn" (click)="resetForm()" [disabled]="!formDataModified()">
      Reset
    </ion-button>
    <ion-button class="filled-blue-btn" (click)="onSubmit()" [disabled]="!formDataModified()">
      Save
    </ion-button>
    <ion-button class="filled-blue-btn" (click)="saveAndNext()" [disabled]="!formDataModified()">
      Save & Next
    </ion-button>
    <ion-button class="unfilled-blue-btn" (click)="goNext()" [disabled]="!itineraryId || formDataModified()">
      <ion-icon slot="icon-only" name="chevron-forward-outline"></ion-icon>
    </ion-button>
  </div>
</form>


